import React from "react";
import { useContext } from "react";
import { StoreContext } from "../../context/StoreContext";
import { Box, Typography } from '@mui/material';

const Logo = () => {
  const { data } = useContext(StoreContext);
  const storeDetails = data.store_master;

  return (
    <>
      {storeDetails.map((store) => (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column', 
          alignItems: 'center',
          gap: '4px', 
          cursor: 'pointer', 
          paddingRight:'20px',
        }}>
          <Box
            component="img"
            src={store.logo} 
            alt={store.storename}
            sx={{
              height: 40, 
              width: 40,  
            }}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 'bold',
              color: 'black', 
              fontSize: '14px',
              textTransform: 'uppercase', 
            }}
          >
            {store.storename}
          </Typography>
        </Box>
      ))}
    </>
  );
};

export default Logo;